module.exports = __webpack_public_path__ + "media/images/Kitchen Cabinets-93ec52f6.jpg";